module.exports = __webpack_public_path__ + "img/footer-hair_rituel-logo.6ed36e32.svg";